import React from 'react';
import { useTranslation } from 'react-i18next';
import { getThemeColors } from '../../../lib/theme';
import { formatDateTime } from '../../../lib/dateFormat';
import { Icon } from '../../../components/icons';
import { useGespraechsprotokolle } from '../../../components/calls/Gespraechsprotokolle';
import { WidgetCard } from './WidgetCard';

/* ─── GespraechsprotokolleWidget (compact) ───────────────────────────────────
 * Die letzten Gespräche kompakt; „Alle anzeigen" führt in den Reiter
 * Kommunikation (dort stehen die vollständigen Gesprächsprotokolle mit
 * Transkripten). Familienkonto: Gespräche aller Mitglieder (Backend). */

export function GespraechsprotokolleWidget({ dark, userId, onShowAll }: {
  dark: boolean; userId: number; onShowAll: (e: React.MouseEvent) => void;
}) {
  const { t } = useTranslation();
  const tc = getThemeColors(dark);
  const { calls, total, loading } = useGespraechsprotokolle(userId, 3);

  return (
    <WidgetCard
      dark={dark}
      title={t('pflege.detail.dashboard.gespraechsprotokolle')}
      badge={total}
      onShowAll={onShowAll}
      showAllLabel={t('pflege.detail.dashboard.alle_anzeigen')}
      loading={loading}
    >
      <div data-testid="widget-gespraechsprotokolle">
        {!loading && calls.length === 0 && (
          <div style={{ padding: '10px 14px', fontSize: 12, color: tc.muted, fontStyle: 'italic' }}>
            {t('pflege.detail.dashboard.gespraechsprotokolle_empty')}
          </div>
        )}
        {calls.map(c => (
          <div key={c.id} style={{ padding: '8px 14px', borderBottom: `1px solid ${tc.borderSoft}` }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <Icon.Phone c={c.status === 'missed' ? '#b42318' : tc.muted} />
              <span style={{ fontSize: 12.5, fontWeight: 500, color: tc.heading, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {c.contact_name ?? c.external_number ?? t('call_history.unknown')}
              </span>
            </div>
            <div style={{ fontSize: 10.5, color: tc.muted, marginTop: 1 }}>
              {formatDateTime(c.started_at)} · {t(`call_history.status.${c.status}`)}
              {' · '}
              {c.transcript ? t('call_history.transcript.status.done') : t('call_history.transcript.none')}
            </div>
          </div>
        ))}
      </div>
    </WidgetCard>
  );
}
